import { getMemberIdWithFallback } from '@trello/authentication';

import {
  useMyAdminRolesFragment,
  type MyAdminRolesFragment,
} from './MyAdminRolesFragment.generated';

/**
 * Returns the member with properties related to the member's PremOrgs or Enterprise Admin
 * roles if applicable.
 */
export const useMyAdminRoles = (): { member?: MyAdminRolesFragment } => {
  const memberId = getMemberIdWithFallback();

  const { data } = useMyAdminRolesFragment({
    from: { id: memberId },
  });

  return { member: data ?? undefined };
};
